import React, { useEffect, useRef } from 'react';
import './ProductWalkthrough.css';

interface ProductWalkthroughProps {
  onComplete: () => void;
}

const ProductWalkthrough: React.FC<ProductWalkthroughProps> = ({ onComplete }) => {
  const arcadeIframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    function onArcadeIframeMessage(e: MessageEvent) {
      if (e.origin !== 'https://demo.arcade.software' || !e.isTrusted) return;

      const arcadeIframe = arcadeIframeRef.current;
      if (!arcadeIframe || !arcadeIframe.contentWindow) return;

      if (e.data.event === 'arcade-init') {
        arcadeIframe.contentWindow.postMessage({ event: 'register-popout-handler' }, '*');
      }

      if (e.data.event === 'arcade-popout-open') {
        arcadeIframe.style.height = '100%';
        arcadeIframe.style.zIndex = '9999999';
      }

      if (e.data.event === 'arcade-popout-close') {
        arcadeIframe.style.height = '0';
        arcadeIframe.style.zIndex = 'auto';
        // Call onComplete when walkthrough is closed
        onComplete();
      }
    }

    window.addEventListener('message', onArcadeIframeMessage);

    // Auto-trigger the walkthrough on component mount
    const arcadeIframe = arcadeIframeRef.current;
    if (arcadeIframe && arcadeIframe.contentWindow) {
      arcadeIframe.contentWindow.postMessage({ event: 'register-popout-handler' }, '*');
      // Auto-trigger the walkthrough
      setTimeout(() => {
        arcadeIframe.contentWindow?.postMessage({ event: 'request-popout-open' }, '*');
      }, 1000);
    }

    return () => {
      if (arcadeIframe && arcadeIframe.contentWindow) {
        arcadeIframe.contentWindow.postMessage({ event: 'unregister-popout-handler' }, '*');
      }
      window.removeEventListener('message', onArcadeIframeMessage);
    };
  }, [onComplete]);

  function onClickArcadeTrigger() {
    const arcadeIframe = arcadeIframeRef.current;
    if (arcadeIframe && arcadeIframe.contentWindow) {
      arcadeIframe.contentWindow.postMessage(
        { event: 'request-popout-open' },
        '*'
      );
    }
  }

  return (
    <div className="product-walkthrough-overlay">
      <div className="walkthrough-content">
        <div className="walkthrough-header">
          <h2>Welcome to Remi!</h2>
          <p>Let's take a quick tour to get you started</p>
        </div>
        
        <button 
          onClick={onClickArcadeTrigger} 
          className="walkthrough-trigger-button"
        >
          🚀 Start Product Tour
        </button>
        
        <iframe
          ref={arcadeIframeRef}
          src="https://demo.arcade.software/h2e2Pqo2RMWdho36x3XP?embed&embed_custom&show_copy_link=true"
          title="Remi Product Walkthrough"
          frameBorder="0"
          loading="lazy"
          allowFullScreen
          allow="clipboard-write"
          className="walkthrough-iframe"
        />
      </div>
    </div>
  );
};

export default ProductWalkthrough;
